module.exports = __webpack_public_path__ + "img/blue-dot.1d8ea84b.svg";